import React from "react";

const ImageFavorite = () => {
	return (
		<svg
			className="image-favorite unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				className="image-fill-color"
				d="M12.1,16.9l4.4,2.3l-0.8-4.8l3.6-3.4l-5-0.7l-2.2-4.4l-2.2,4.4l-5,0.7l3.6,3.4l-0.8,4.8L12.1,16.9z M12.1,19
	l-6.9,3.6L6.6,15L1,9.6l7.7-1.1l3.4-7l3.4,7l7.7,1.1L17.7,15l1.3,7.7L12.1,19z"
			/>
		</svg>
	);
};

export default ImageFavorite;
